import type { StaffRole } from '@/store/authStore';
import { useAuthStore } from '@/store/authStore';

/**
 * 현재 로그인 사용자가 주어진 역할 중 하나라도 가지고 있는지 확인.
 * 인자를 비우면 로그인 여부만 체크.
 */
export function useHasRole(...roles: StaffRole[]): boolean {
  const role = useAuthStore((s) => s.staff?.role);
  if (!role) return false;
  if (roles.length === 0) return true;
  return roles.includes(role);
}
